import { Component, Input, OnInit } from '@angular/core';
import { SearchObject, SearchObjectService } from 'src/app/shared/services/search-object.service';

@Component({
    selector: 'app-banners',
    templateUrl: './banners.component.html',
    styleUrls: ['./banners.component.scss']
})
export class BannersComponent implements OnInit {

    @Input() showAnywhereCare?: boolean;
    @Input() isPCPSearch?: boolean;

    searchObject!: SearchObject;

    constructor(private searchObjectService: SearchObjectService) {
        this.searchObject = this.searchObjectService.getSearchObject();
    }

    ngOnInit(): void {
    }

    isShowBehavioral() {
    return ((this.searchObjectService.getCareType() === 'Behavioral Health' && ['Counseling', 'Marriage & Family Therapy', 'Mental Health Outpatient', 'Psychiatry', 'Psychology'].includes(this.searchObject.specialty) && !['0000010000010001200005','0000010000010001200006'].includes(this.searchObject?.networkId)));
  }

}
